import { removeMarketingCookies } from '@/features/CCPACookies/helpers';
import {
	FacebookService,
	GoogleService,
	MicrosoftAdsService,
} from '@/services';
import { getFbPixelId } from '@/helpers/getFbPixelId';

/**
 * Safety net: tear down any marketing/analytics trackers that may have loaded
 * earlier in the session before GPC was evaluated. Mirrors the removal sequence
 * used by the CCPA "Don't Sell" flow (see useSetCookies.ts).
 */
export const removeMarketingTrackers = (): void => {
	FacebookService.remove(getFbPixelId());
	GoogleService.remove();
	MicrosoftAdsService.remove();
	removeMarketingCookies();
};
